import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsRadioModel } from "src/app/models/widgets/widgets-radio.model";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { WidgetsService } from "../widgets/widgets.service";
import { WidgetsMetadataService } from "../widgets/widgets-metadata.service";
import { Logger } from "src/app/core/logger";
import { WidgetsSelectionService } from "../widgets/widgets-selection.service";

@Injectable()
export class CommandRadioService extends CommandAction {
    constructor(
        private widgetsService: WidgetsService,   
        private selectionService: WidgetsSelectionService, 
        private widgetsMetadataService: WidgetsMetadataService,
        private logger:Logger) {
        super();
    }

    public execute(parent:WidgetsAbstract, widget: WidgetsAbstract): WidgetsRadioModel {
        const newWidget = new WidgetsRadioModel();
        newWidget.parentId =  parent.id;
        newWidget.type = "radio";
        newWidget.key = this.widgetsService.getNextKey(newWidget.type);

        // A new Primitive borns selected
        this.selectionService.select(newWidget).then(() => {
            this.widgetsService.setLayoutTouched();
        });
        return newWidget;        
    }
}
